var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.238 5.14072C13.1405 4.28701 12.463 3.60948 11.6093 3.51204L10.8099 4.3114C11.5263 4.64476 12.1052 5.22373 12.4386 5.94008L13.238 5.14072ZM5.74047 9.38085L9.60928 5.51204C10.463 5.60948 11.1405 6.28701 11.238 7.14072L7.36915 11.0095C7.34152 11.0372 7.31289 11.0636 7.28335 11.0889C7.07656 11.2657 6.82492 11.3835 6.55509 11.4285L5.07483 11.6752L5.32154 10.1949C5.37294 9.88653 5.5194 9.60192 5.74047 9.38085ZM10.7194 2.28061L8.71939 4.2806L4.67981 8.32019C4.23768 8.76232 3.94474 9.33155 3.84195 9.94831L3.48016 12.119C3.36736 12.7959 3.95413 13.3826 4.63095 13.2698L6.80169 12.9081C7.41845 12.8053 7.98768 12.5123 8.42981 12.0702L12.4694 8.03061L14.4694 6.03061C14.6491 5.85094 14.75 5.60725 14.75 5.35316C14.75 3.50126 13.2487 2 11.3968 2C11.1427 2 10.8991 2.10094 10.7194 2.28061ZM3.75 14.5C3.33579 14.5 3 14.8358 3 15.25C3 15.6642 3.33579 16 3.75 16H14.25C14.6642 16 15 15.6642 15 15.25C15 14.8358 14.6642 14.5 14.25 14.5H3.75Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ACB2C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenSmall);
export default __webpack_public_path__ + "static/media/penSmall.45accd8647002ef83c50d45a8d885c07.svg";
export { ForwardRef as ReactComponent };